<ng-container *ngIf="page && !isEditMode">
  <div class="portfolio-entry item has-edit-button">
    <div
      class="portfolio-entry__msg portfolio-entry__msg--not-found"
      *ngIf="!componentConfig && (debugMode$ | async)"
    >
      No component found for "{{ componentType }}""
    </div>
    <div
      class="portfolio-entry__msg portfolio-entry__msg--error"
      *ngIf="errorMsg && (debugMode$ | async)"
    >
      Data error: {{ errorMsg }}
    </div>
    <div
      class="portfolio-entry__msg portfolio-entry__msg--loading"
      *ngIf="isLoading"
    >
      {{ "products.loading" | translate }}
    </div>
    <ng-template #dynamicCmp></ng-template>
  </div>
</ng-container>
<ng-container *ngIf="page && isEditMode">
  <div class="portfolio-entry item has-edit-button">
    <h5 *ngIf="componentType; else configureComponentBlock">
      Portfolio Component - {{ componentType }}
    </h5>
  </div>
  <ng-template #configureComponentBlock
    >Click to configure Portfolio Component</ng-template
  >
</ng-container>
